import React from "react";
import PropTypes, { node } from "prop-types";
import Prism from "prismjs";

import { graphlib, render as dagreD3Render, intersect } from "dagre-d3";

import * as d3 from "d3";
import _ from "lodash";
import { withResizeDetector } from "react-resize-detector";
import parseSvgPath from "parse-svg-path";
import { IconButton, Toolbar } from "@material-ui/core";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
import ZoomOutMapIcon from "@material-ui/icons/ZoomOutMap";
import FullscreenExitIcon from "@material-ui/icons/FullscreenExit";
import HomeIcon from "@material-ui/icons/Home";
import "./diagram.scss";
import { rectUI } from "./nodes/WorkflowTasksForeign";
import { ArrowBack, Refresh } from "@material-ui/icons";
import { TaskType, ExecutionStatus } from "../../utils/constants";
import { splitTaskReferenceName } from "../../utils/helpers";
import StatusBadge from "../../components/StatusBadge";
import ca from "date-fns/locale/ca";
import { he, sv, tr } from "date-fns/locale";
import { useLayoutEffect } from "react";
import DefaultLoader from "../DefaultLoader";
import ConfirmChoiceDialog from "../ConfirmChoiceDialog";

const BAR_MARGIN = 50;
const BOTTOM_MARGIN = 30;
const GRAPH_MIN_HEIGHT = 600;

class WorkflowGraph extends React.Component {
  constructor(props) {
    super(props);
    this.renderer = new dagreD3Render();
    this.renderer.shapes().bar = barRenderer;
    this.renderer.shapes().stack = stackRenderer;
    this.renderer.shapes().rect = rectRenderer;

    this.encloserBoundries = [];

    this.svgRef = React.createRef();
    this.zoom = null;

    this.state = {
      isLoaded: false,
      isFullscreen: false,
      setClickedDeleteBtn: false,
      addBtnClicked: false,
      // windowWidth: 0,
      // windowHeight: 0,
    };
    this.timeOut = null;

    this.refreshButtonRef = React.createRef();
    this.refreshSummaryButtonRef = React.createRef();
    var zoomeScale = 0.65;
    this.dpr = props.dpr ?? 1;
    this.closeRightPanel = this.closeRightPanel.bind(this);
    // this.loopThroughAllNodes();
  }

  closeRightPanel() {
    if (this.props.executionMode) {
      this.props.deselectTaskAndCloseRightPanel();
    }
  }

  loopThroughAllNodes() {
    setTimeout(async () => {
      const dagGraph = this.props.dag.graph;
      var x = 0;
      var y = 0;
      const switchToNode = (nodeId, isFirstNode) => {
        return new Promise((resolve, reject) => {
          this.zoomToNode(nodeId, isFirstNode);
          setTimeout(() => {
            resolve();
          }, 3000);
        });
      };
      // Clone graph

      // var indexes = [0, 1, 2, 3];
      // for (let index = 0; index < indexes.length; index++) {
      //   // const element = array[index];
      //   const nodeId = dagGraph.nodes()[indexes[index]];
      //   await switchToNode(dagGraph.node(nodeId), index == 0);
      //   // break;
      // }
      for (let index = 0; index < dagGraph.nodes().length; index++) {
        const nodeId = dagGraph.nodes()[index];
        await switchToNode(dagGraph.node(nodeId), index === 0);
        // break;
      }
    }, 5000);
  }

  // updateDimensions = () => {
  //   this.setState({ width: window.innerWidth, height: window.innerHeight });
  // };

  componentWillReceiveProps(props) {
    if (this.state.isLoaded === false) {
      setTimeout(() => {
        this.closeRightPanel();
        this.handleRefresh();
      }, 600);
    }
  }
  componentDidUpdate(prevProps) {
    // useEffect on dag
    this.drawGraph();
    this.zoomHome();
    Prism.highlightAll();
    if (this.state.isLoaded === true) {
      setTimeout(() => {
        this.handleRefresh();
      }, 600);
    }

    // useEffect on selectedRef
    if (prevProps.selectedTask !== this.props.selectedTask) {
      this.highlightSelectedNode();
    }

    if (
      _.isEmpty(this.props.selectedTask) &&
      _.isEmpty(prevProps.selectedTask) &&
      !this.props.executionMode
    ) {
      this.zoomHome(true);
    }

    if (
      this.props.executionMode &&
      (this.props.svgLoading || this.props.isFetching)
    ) {
      if (!this.props.svgLoading && this.props.isFetching)
        this.props.setSvgLoading(true);
      this.zoomHome(true);
    }
  }

  // componentWillUnmount() {
  //   // window.removeEventListener("resize", this.updateDimensions);
  //   this.zoom = null;
  //   this.svgRef = null;
  //   this.renderer = null;
  // }

  componentDidMount() {
    // window.addEventListener("resize", this.updateDimensions);
    this.svg = d3.select(this.svgRef.current);
    this.svg.attr("class", "svg-container");
    // this.svg.attr("viewBox", "0 0 700 500");
    // this.svg.attr("preserveAspectRatio", "xMinYMin meet");
    this.svg.selectAll("g.node").classed("selected", false);

    // Set up zoom support
    this.zoom = d3
      .zoom()
      .extent([
        [0, 0],
        [300, 300],
      ])
      .filter((event) => {
        if (event.type === "wheel") {
          const currTransform = d3.zoomTransform(this.inner.node());
          let scale = 0.65;
          let posX = currTransform.x;
          let posY = currTransform.y;

          if (event.ctrlKey) {
            return true;
          } else {
            posX -= event.deltaX * 2;
            posY -= event.deltaY * 2;
            scale = currTransform.k;
          }
          this.zoomeScale = scale;
          window.requestAnimationFrame(() => {
            this.svg.call(
              this.zoom.transform,
              d3.zoomIdentity.translate(posX, posY).scale(scale)
            );
          });
          return event.ctrlKey;
        } else if (event.type === "dblclick") {
          return false; // ignore dblclick
        } else {
          return !event.ctrlKey && !event.button;
        }
      })
      .on("zoom", (event) => {
        if (event.transform.k > 1.2) {
          event.transform.k = 1.2;
        }
        if (event.transform.k < 0.082) {
          event.transform.k = 0.082;
        }
        this.inner.attr("transform", event.transform);
      });

    this.zoom(this.svg);

    this.drawGraph();
    this.highlightSelectedNode();
    Prism.highlightAll();

    if (this.state.isLoaded == false) {
      clearTimeout(this.timeOut);
      setTimeout(() => {
        this.handleRefresh();
        this.setState({ ...this.state, isLoaded: true });
      }, 300);
    }
  }

  highlightSelectedNode = () => {
    const dagGraph = this.props.dag.graph;
    const taskResult = this.props.dag.resolveTaskResult(
      this.props.selectedTask
    );
    const selectedRef = taskResult
      ? taskResult.referenceTaskName ||
        taskResult.workflowTask.taskReferenceName
      : this.props.selectedTask.ref;

    let resolvedRef;
    if (!selectedRef) {
      resolvedRef = null;
    } else if (this.graph.hasNode(selectedRef)) {
      resolvedRef = selectedRef;
    } else if (dagGraph.hasNode(selectedRef)) {
      // if ref cannot be found in this.graph, it may be rendered as a stacked placeholder.

      const parentRef = _.first(dagGraph.predecessors(selectedRef));
      const parentType = dagGraph.node(parentRef).type;

      resolvedRef = this.graph
        .successors(parentRef)
        .find((ref) => ref.includes("DF_TASK_PLACEHOLDER"));
    } else {
      throw new Error("Assertion failed. ref not found");
    }

    const { inner } = this;
    inner.selectAll("g.node").classed("selected", false);

    if (resolvedRef) {
      inner
        .select(`g[id*='${splitTaskReferenceName(resolvedRef)}']`)
        .classed("selected", true);
    }
  };

  zoomInOut = (dir) => {
    const { svg, inner } = this;
    const containerWidth = svg.node().getBoundingClientRect().width;
    const rightDrawer = document.getElementById("right-drawer");
    let rightDrawerWidth = 0;
    if (rightDrawer) rightDrawerWidth = rightDrawer.offsetWidth;

    const currTransform = d3.zoomTransform(inner.node());
    const nodesContainerSize = svg
      .select("g.nodes")
      .node()
      .getBoundingClientRect();

    const newZoom =
      dir === "in" ? currTransform.k * 0.8 : currTransform.k / 0.8;

    var newScale = null;

    if (newZoom > 0.082 && newZoom < 1.2) {
      newScale = newZoom;
      this.zoomeScale = newZoom;
    } else if (newZoom > 1.2) {
      newScale = 1.2;
      this.zoomeScale = 1.2;
    } else if (newZoom < 0.082) {
      newScale = 0.082;
      this.zoomeScale = 0.082;
    }

    svg.call(
      this.zoom.transform,
      d3.zoomIdentity
        .translate(
          (containerWidth -
            nodesContainerSize.width -
            rightDrawerWidth * newScale) /
            2,
          20
        )
        .scale(newScale)
    );
  };

  zoomHome = (setScale = false) => {
    const { svg, inner } = this;
    // when execution right drawer available
    const rightDrawer = document.getElementById("right-drawer");
    let rightDrawerWidth = 0;
    if (rightDrawer) rightDrawerWidth = rightDrawer.offsetWidth;
    // when execution right drawer available

    let scale = 0.65;
    const currTransform = d3.zoomTransform(inner.node());
    scale = setScale ? scale : currTransform.k;
    this.zoomeScale = scale;
    d3.zoom().scaleExtent([0.082, 1.2]);

    svg.call(
      this.zoom.transform,
      d3.zoomIdentity.translate(currTransform.x, currTransform.y).scale(scale)
    );

    const containerWidth = svg.node().getBoundingClientRect().width;
    const graphWidth = inner.node().getBoundingClientRect().width;

    let x = setScale
      ? (containerWidth - graphWidth - rightDrawerWidth * scale) / 2
      : currTransform.x;
    let y = setScale ? 40 : currTransform.y;
    this.zoomeScale = scale;

    // Check if addbtn has been clicked before making the second zoom call
    if (!this.state.addBtnClicked) {
      svg.call(
        this.zoom.transform,
        d3.zoomIdentity.translate(x, y).scale(scale)
      );
    }

    const postZoomedHeight = inner.node().getBoundingClientRect().height;

    svg.attr(
      "height",
      Math.max(postZoomedHeight + BOTTOM_MARGIN, GRAPH_MIN_HEIGHT)
    );

    if (this.props.svgLoading) {
      setTimeout(() => {
        this.props.setSvgLoading(false);
      }, 2000);
    }
  };

  handleRefresh = () => {
    const { svg, inner } = this;
    if (this.refreshButtonRef.current) {
      this.refreshButtonRef.current.disabled = true; // Disable the button
    }

    const dagGraph = this.props.dag.graph;
    var nodeRef = "";
    var startNodeRef = "";
    var completeNodeRef = "";
    var selectedNodeRef = "";

    selectedNodeRef = svg.select("g.node.selected").node();
    if (selectedNodeRef != null && selectedNodeRef != "") {
      nodeRef = selectedNodeRef;
    } else {
      for (const node of this.graph.nodes()) {
        if (node != "") {
          const v = dagGraph.node(node) || this.graph.node(node);
          if (
            (v && v.status === ExecutionStatus.InProgress) ||
            v.status === ExecutionStatus.Scheduled
          ) {
            nodeRef = v;
            break;
          }
          if (
            v &&
            v.status === ExecutionStatus.Completed &&
            v.ref !== "__final"
          ) {
            completeNodeRef = v;
          }
          if (v && v.type === TaskType.Terminal && v.ref === "__start") {
            startNodeRef = v;
          }
        }
      }
      if (nodeRef == "" && completeNodeRef != "") {
        nodeRef = completeNodeRef;
      }

      if (nodeRef == "" && startNodeRef != "") {
        nodeRef = startNodeRef;
      }
    }
    // for (const node of this.graph.nodes()) {
    //   if (node != "") {
    //     const v = dagGraph.node(node) || this.graph.node(node);
    //     console.log("V: ", v);
    //     if (
    //       (v && v.status === ExecutionStatus.InProgress) ||
    //       v.status === ExecutionStatus.Scheduled
    //     ) {
    //       nodeRef = v;
    //       break;
    //     }
    //     if (
    //       v &&
    //       v.status === ExecutionStatus.Completed &&
    //       v.ref !== "__final"
    //     ) {
    //       completeNodeRef = v;
    //     }
    //     if (v && v.type === TaskType.Terminal && v.ref === "__start") {
    //       startNodeRef = v;
    //     }
    //   }
    // }
    // if (nodeRef == "" && completeNodeRef != "") {
    //   nodeRef = completeNodeRef;
    // }

    // if (nodeRef == "" && startNodeRef != "") {
    //   nodeRef = startNodeRef;
    // }

    if (this.props.componentLoadedFrom !== "Definition") {
      if (nodeRef != null && nodeRef != "" && nodeRef.ref != "__start") {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.zoomToNode(nodeRef, false);
        }, 600);
      } else if (nodeRef != null && nodeRef != "" && nodeRef.ref == "__start") {
        clearTimeout(this.timeOut);
        this.timeOut = setTimeout(() => {
          this.zoomToNode(nodeRef, true);
        }, 600);
      }
    }
  };

  zoomToNode(node, isFirstNode = false) {
    const { svg } = this;
    // Find the node with the given ID
    var inProgressNode = null;
    var inProgressNodeSize = null;

    inProgressNode = svg.select(`#${node.ref}`);

    // Get svg container element and its dimensions
    var svgContainerElement = d3.select("svg.svg-container").node();
    var svgContainerSize = null;
    if (svgContainerElement) {
      svgContainerSize = svgContainerElement.getBoundingClientRect();
    }

    // Check if the node exists and svg is loaded (we get the size of svg container)
    if (!inProgressNode.empty() && inProgressNode.node() && svgContainerSize) {
      // Get the dimensions of the the selected node
      inProgressNodeSize = inProgressNode.node().getBoundingClientRect();

      // Get the transformation for the selected node
      const nodeTransform = inProgressNode.node().transform.baseVal.getItem(0)
        .matrix;
      var posX = nodeTransform.e * this.zoomeScale - svgContainerSize.width / 2;
      var posY = 0;
      var firstNodeOffset = 0;
      if (this.props.executionMode && this.props.showOnlyDiagram) {
        //Ticket Summary
        if (isFirstNode) {
          firstNodeOffset = 95;
        }
        posY =
          nodeTransform.f * this.zoomeScale -
          (svgContainerSize.height * this.zoomeScale) / 2 +
          inProgressNodeSize.height +
          firstNodeOffset;
      } else if (this.props.executionMode && !this.props.showOnlyDiagram) {
        // Working for Execution
        if (isFirstNode) {
          firstNodeOffset = 0;
        }
        posY =
          nodeTransform.f * this.zoomeScale -
          // nodeTransform.f * this.zoomeScale -
          svgContainerSize.height / 2 -
          firstNodeOffset;
      }

      if (
        svgContainerSize.width / 2 >
        nodeTransform.e * this.zoomeScale
        // nodeTransform.e * this.zoomeScale
      ) {
        posX = Math.abs(posX);
      } else {
        posX = Math.abs(posX) * -1;
      }

      if (
        (svgContainerSize.height * this.zoomeScale) / 2 >
        nodeTransform.f * this.zoomeScale
      ) {
        posY = Math.abs(posY + 30); // last change - added y offset
      } else {
        posY = Math.abs(posY + 30) * -1; // last change - added y offset
      }

      // document.getElementById(
      //   "myspan"
      // ).textContent = `${node.ref}: ${posX}, ${posY}`;

      window.requestAnimationFrame(() => {
        this.svg.call(
          this.zoom.transform,
          d3.zoomIdentity.translate(posX, posY).scale(this.zoomeScale)
        );
      });
    }
    setTimeout(() => {
      if (this.state.isFullscreen && this.refreshButtonRef.current) {
        this.refreshButtonRef.current.disabled = false; // Disable the button
      } else if (
        !this.state.isFullscreen &&
        this.refreshSummaryButtonRef.current
      ) {
        this.refreshSummaryButtonRef.current.disabled = false;
      }
    }, 1000);
  }

  zoomToFit = () => {
    const { svg, inner } = this;
    const containerWidth = svg.node().getBoundingClientRect().width;
    const graphWidth = this.graph.graph().width;
    // when execution right drawer available
    const rightDrawer = document.getElementById("right-drawer");
    let rightDrawerWidth = 0;
    if (rightDrawer) rightDrawerWidth = rightDrawer.offsetWidth;
    // when execution right drawer available

    const scale = Math.min(containerWidth / this.graph.graph().width, 0.5);
    this.zoom.transform(svg, d3.zoomIdentity.scale(scale));

    // Adjust svg height to fit post-zoomed
    const postZoomedHeight = inner.nodes()[0].getBoundingClientRect().height;
    svg.call(
      this.zoom.transform,
      d3.zoomIdentity
        .translate(
          (containerWidth - graphWidth - rightDrawerWidth * scale) / 2,
          20
        )
        .scale(scale)
    );
    svg.attr(
      "height",
      Math.max(postZoomedHeight + BOTTOM_MARGIN, GRAPH_MIN_HEIGHT)
    );
  };

  toggleZoom = () => {
    if (!this.state.isFullscreen) {
      if (document.getElementById("exe-header"))
        document.getElementById("exe-header").style.display = "none";
      if (document.getElementById("exe-subheader"))
        document.getElementById("exe-subheader").style.display = "none";
      if (document.getElementById("main-header"))
        document.getElementById("main-header").style.display = "none";
      if (document.getElementById("main-body"))
        document.getElementById("main-body").style.padding = "0";
      this.setState({
        ...this.state,
        isFullscreen: true,
      });
    } else {
      if (document.getElementById("exe-header"))
        document.getElementById("exe-header").style.display = "";
      if (document.getElementById("exe-subheader"))
        document.getElementById("exe-subheader").style.display = "";
      if (document.getElementById("main-header"))
        document.getElementById("main-header").style.display = "";
      if (document.getElementById("main-body"))
        document.getElementById("main-body").style.padding = "";
      this.setState({
        ...this.state,
        isFullscreen: false,
      });
    }
  };

  collapseDfChildren = (parentRef, childrenRef) => {
    const graph = this.graph;
    const dagGraph = this.props.dag.graph;

    const tally = childrenRef
      .map((childRef) => dagGraph.node(childRef).status)
      .reduce(
        (prev, curr) => {
          const retval = { total: prev.total + 1 };
          if (curr === ExecutionStatus.Completed) {
            retval.success = prev.success + 1;
          } else if (
            curr === ExecutionStatus.InProgress ||
            curr === ExecutionStatus.Scheduled
          ) {
            retval.inProgress = prev.inProgress + 1;
          } else if (curr === ExecutionStatus.Cancelled) {
            retval.canceled = prev.canceled + 1;
          }
          return {
            ...prev,
            ...retval,
          };
        },
        {
          success: 0,
          inProgress: 0,
          canceled: 0,
          total: 0,
        }
      );

    const placeholderRef = parentRef + "_DF_TASK_PLACEHOLDER";

    let status;
    if (tally.success === tally.total) {
      status = ExecutionStatus.Completed;
    } else if (tally.inProgress) {
      status = ExecutionStatus.InProgress;
    } else {
      status = ExecutionStatus.Failed;
    }

    const placeholderNode = {
      name: placeholderRef,
      ref: placeholderRef,
      type: "DF_TASK_PLACEHOLDER",
      status: status, // Only used for coloring
      firstDfRef: _.first(childrenRef),
      tally: tally,
    };
    graph.setNode(placeholderRef, placeholderNode);

    const tailSet = new Set();
    for (const childRef of childrenRef) {
      graph
        .successors(childRef)
        .forEach((successorRef) => tailSet.add(successorRef));
      graph.removeNode(childRef); // This automatically removes any incident edges
    }

    // Add edges for placeholder
    graph.setEdge(parentRef, placeholderRef, { executed: true });

    // Should have only 1 unique successor (being a JOIN)
    console.assert(tailSet.size === 1);

    const successorRef = tailSet.values().next().value;
    const successor = dagGraph.node(successorRef);

    graph.setEdge(
      placeholderRef,
      successorRef,
      successor.status ? { executed: true } : undefined
    );
  };

  drawGraph = () => {
    if (this.inner) this.inner.remove();
    this.inner = this.svg.append("g");
    const { svg, inner } = this;

    const graph = new graphlib.Graph({ compound: true }).setGraph({
      // nodesep: 120,
      // nodesep: 15,
      // marginx: 300,
      // marginy: 300,
      // rankdir: "LR",
      edgesep: 500,
      ranksep: 40,
    });
    this.graph = graph;
    this.barNodes = [];

    const dagGraph = this.props.dag.graph;

    // Clone graph
    for (const nodeId of dagGraph.nodes()) {
      graph.setNode(nodeId);
    }

    for (const { v, w } of dagGraph.edges()) {
      graph.setEdge(v, w);
    }

    // Collapse Dynamic Fork children

    const dfNodes = dagGraph
      .nodes()
      .filter((nodeId) => dagGraph.node(nodeId).type === "FORK_JOIN_DYNAMIC");

    for (const parentRef of dfNodes) {
      const childRefs = dagGraph.successors(parentRef);
      if (childRefs.length > 2) {
        this.collapseDfChildren(parentRef, childRefs);
      }
    }

    // Collapse Do_while children
    const doWhileNodes = dagGraph
      .nodes()
      .filter((nodeId) => dagGraph.node(nodeId).type === TaskType.DoWhile);

    for (const parentRef of doWhileNodes) {
      const parentNode = dagGraph.node(parentRef);

      // Only collapse executed DO_WHILE loops
      if (_.get(parentNode, "status")) {
        const childRefs = dagGraph
          .successors(parentRef)
          .map((ref) => dagGraph.node(ref))
          // .filter((node) => node.type !== "DO_WHILE_END")
          // .filter((node) => node.type !== TaskType.EndOfDoWhile)
          .filter((node) => node.type !== TaskType.Label)
          .map((node) => node.ref);

        if (childRefs.length > 0) {
          this.collapseDfChildren(parentRef, childRefs);
        }
      }
    }

    // Render Nodes
    var nodeRef = "";
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;

    for (const nodeId of graph.nodes()) {
      if (nodeId != "") {
        const v = dagGraph.node(nodeId) || graph.node(nodeId);
        if (
          v.status === ExecutionStatus.InProgress ||
          v.status === ExecutionStatus.Scheduled
        ) {
          nodeRef = v;
        }
        var retVal = this.renderVertex(nodeId);
        // graph.setNode(nodeId, this.renderVertex(nodeId)); // Update nodes with render info
        graph.setNode(nodeId, retVal); // Update nodes with render info
      }
    }

    // Render Edges
    for (const edgeId of graph.edges()) {
      const dagEdge = dagGraph.edge(edgeId) || graph.edge(edgeId);

      const caseValue = _.get(dagEdge, "caseValue");
      const type = _.get(dagEdge, "type");

      let classes = [],
        label,
        labelStyle;

      if (type === "loop") {
        // label = "LOOP";
        classes.push("reverse");
      }
      // Adds labels to SWITCH CASE
      // else{
      //   label = caseValue || (caseValue === null ? "Default" : "");
      // }

      if (this.props.executionMode) {
        const executed = _.get(dagEdge, "executed");
        if (executed) {
          classes.push("executed");
          labelStyle = "";
        } else {
          classes.push("dimmed");
          labelStyle = "fill: #ccc";
        }
      }

      graph.setEdge(edgeId.v, edgeId.w, {
        label: label,
        labelStyle: labelStyle,
        class: classes.join(" "),
        curve: d3.curveBasis,
      });
    }

    this.renderer(inner, graph);

    // Expand barNodes and rerender
    for (const barRef of this.barNodes) {
      this.expandBar(barRef);
    }
    // svg.width=100% via CSS
    svg.attr("height", graph.graph().height + BOTTOM_MARGIN);

    // Fix dagre-d3 bug with marker-end. Use css to set marker-end
    // See: https://github.com/dagrejs/dagre-d3/pull/413
    d3.selectAll("path.path").attr("marker-end", "");

    // Attach click handler
    inner.selectAll("g.node").on("click", this.handleClick);
    // attach click handler for add btn
    inner.selectAll("g.addbtn").on("click", this.handleAddClick);
    inner.selectAll("g.subtractbtn").on("click", this.handleSubtractClick);
    // attach click handler for delete btn
    inner.selectAll(".DeleteButton").on("click", this.handleDeleteClick);

    // this.svg.attr("width", graphWidth).attr("height", graphHeight);
    // Optionally, set viewBox attribute for responsiveness
    // this.svg.attr("viewBox", `0 0 ${graphWidth} ${graphHeight}`);

    // Optionally, set CSS for responsiveness

    this.svg.style("max-width", "100%").style("height", "auto");

    for (const nodeId of graph.nodes()) {
      if (nodeId != "") {
        const v = dagGraph.node(nodeId) || graph.node(nodeId);
        if (
          v.type === TaskType.Label &&
          v.name === "LABEL_START_TRIGGER_APPROVAL"
        ) {
          let taskNodeSize = null;
          var taskNode = this.svg.select(
            `.node.type-${TaskType.Label}#${v.ref}`
          );

          if (!taskNode.empty()) {
            taskNodeSize = taskNode.node().getBoundingClientRect();
            this.encloserBoundries.push({
              id: v.ref + "-box",
              width: retVal.width + 80,
              height: retVal.height + 30,
              x: (taskNodeSize.width / 2) * -1, // Bring X
              y: -50, // Bring Y
              heightOffset: taskNodeSize.y,
              widthOffset: taskNodeSize.x,
              originalLeftOffset: taskNodeSize.x,
              fillColor: "lightblue",
            });
          }
        } else if (
          v.type === TaskType.Label &&
          v.name === "LABEL_START_SUB_WORKFLOW"
        ) {
          let taskNodeSize = null;
          var taskNode = this.svg.select(
            `.node.type-${TaskType.Label}#${v.ref}`
          );

          if (!taskNode.empty()) {
            taskNodeSize = taskNode.node().getBoundingClientRect();

            this.encloserBoundries.push({
              id: v.ref + "-box",
              width: retVal.width + 10,
              height: retVal.height + 30,
              x: (taskNodeSize.width / 2) * -1, // Bring X
              y: -50, // Bring Y
              heightOffset: taskNodeSize.y,
              widthOffset: taskNodeSize.x,
              originalLeftOffset: taskNodeSize.x,
              fillColor: "black",
            });
          }
        }
        if (this.encloserBoundries.length) {
          var taskNode = this.svg.select(`#${v.ref}`);
          if (!taskNode.empty()) {
            const taskNodeSize = taskNode.node().getBoundingClientRect();
            this.encloserBoundries.forEach((boundary) => {
              minX = Math.min(taskNodeSize.x, boundary.widthOffset);
              if (taskNodeSize.x < boundary.widthOffset) {
                boundary.x =
                  boundary.x - (boundary.widthOffset - taskNodeSize.x);
                boundary.widthOffset = taskNodeSize.x;
              }

              maxX = Math.max(
                taskNodeSize.x - boundary.widthOffset + taskNodeSize.width,
                boundary.width
              );

              boundary.width = maxX + (v.type.includes("DO_WHILE") ? 60 : 0);
              maxY = Math.max(
                taskNodeSize.y - boundary.heightOffset + taskNodeSize.height,
                boundary.height
              );
              boundary.height = taskNodeSize.bottom - boundary.heightOffset;
            });
          }
        }
        if (
          (v.type === TaskType.Label &&
            v.name === "LABEL_END_TRIGGER_APPROVAL") ||
          v.name === "LABEL_END_SUB_WORKFLOW"
        ) {
          // Change x, y, width & height of Label Container
          const obj = this.encloserBoundries.pop();
          var rectBg = this.svg.select(`#${obj.id}`).node();

          // const parentNode = this.svg.select(`#${obj.id}`).node().parentNode;
          // d3.select(parentNode).lower();

          rectBg.setAttribute("width", obj.width + 100);
          rectBg.setAttribute("height", obj.height - 40);
          rectBg.setAttribute("x", obj.x - 50);
          rectBg.setAttribute("y", obj.y);
          rectBg.setAttribute("fill", obj.fillColor);
        }
        // else if (
        //   v.type === TaskType.Label &&
        //   v.name === "LABEL_END_SUB_WORKFLOW"
        // ) {
        //   // Change x, y, width & height of Label Container
        //   const obj = this.encloserBoundries.pop();
        //   var rectBg = this.svg.select(`#${obj.id}`).node();

        //   // const parentNode = this.svg.select(`#${obj.id}`).node().parentNode;
        //   // d3.select(parentNode).lower();

        //   rectBg.setAttribute("width", obj.width + 100);
        //   rectBg.setAttribute("height", obj.height - 40);
        //   rectBg.setAttribute("x", obj.x - 50);
        //   rectBg.setAttribute("y", obj.y);
        //   rectBg.setAttribute("fill", obj.fillColor);
        // }
      }
    }
  };

  /**
   * Get the taskRef id base on browsers
   * @param e
   * @returns {string | undefined} The id of the task ref
   */
  getTaskRef = (e) => {
    const flag =
      navigator.userAgent.toLowerCase().indexOf("firefox") > -1 ||
      navigator.userAgent.toLowerCase().indexOf("chrome") > -1;
    if (flag) {
      return e.target?.parentNode?.id;
    }
    return e?.path[1]?.id || e?.path[2]?.id; // could be 2 layers down
  };

  handleClick = (e) => {
    e.stopPropagation();
    if (
      !_.isUndefined(this.props.hasEditorLoaded) &&
      !this.props.hasEditorLoaded
    )
      return;
    if (!_.isUndefined(this.props.isLoading) && this.props.isLoading) return;
    if (!this.props.executionMode) this.props.setIsLoading(true);
    const taskRef =
      e.composedPath()[1].id ||
      e.composedPath()[2].id ||
      e.composedPath()[3].id ||
      e.composedPath()[4].id ||
      e.composedPath()[6].id ||
      e.composedPath()[8].id ||
      e.composedPath()[9].id ||
      e.composedPath()[10].id; // could be 2 layers down

    const node = this.graph.node(taskRef);
    this.inner.selectAll("g.node").classed("selected", false);
    if (node && node.type === "DF_TASK_PLACEHOLDER") {
      if (this.props.onClick) this.props.onClick({ ref: node.firstDfRef });
    } else if (
      node &&
      (node.type === "DF_EMPTY_PLACEHOLDER" || node.type === "TERMINAL")
    ) {
      return null; // No-op for click on unexecuted DF card-pile or terminal nodes
    } else {
      // Non-DF, or unexecuted DF vertex
      if (this.props.onClick) {
        // if(this.props.isLoading){
        this.inner
          .select(`g[id*='${splitTaskReferenceName(taskRef)}']`)
          .classed("selected", true);
        this.props.onClick({ ref: taskRef });
      }

      // }
    }
  };

  handleAddClick = (e) => {
    e.stopPropagation();
    this.setState({ addBtnClicked: true });
    const taskRef =
      e.composedPath()[2].id ||
      e.composedPath()[4].id ||
      e.composedPath()[5].id; // could be 2 layers down

    const node = this.graph.node(taskRef);

    if (node && node.type === "DF_TASK_PLACEHOLDER") {
      // if (this.props.onClick) this.props.onClick({ ref: node.firstDfRef });
    } else if (node && node.type === "DF_EMPTY_PLACEHOLDER") {
      return null; // No-op for click on unexecuted DF card-pile or terminal nodes
    } else {
      // Non-DF, or unexecuted DF vertex
      if (this.props.onAddBtnClick) this.props.onAddBtnClick({ ref: taskRef });
    }
  };
  handleSubtractClick = (e) => {
    e.stopPropagation();
    this.setState({ addBtnClicked: true });
    const taskRef =
      e.composedPath()[2].id ||
      e.composedPath()[4].id ||
      e.composedPath()[5].id; // could be 2 layers down

    const node = this.graph.node(taskRef);

    if (node && node.type === "DF_TASK_PLACEHOLDER") {
      // if (this.props.onClick) this.props.onClick({ ref: node.firstDfRef });
    } else if (node && node.type === "DF_EMPTY_PLACEHOLDER") {
      return null; // No-op for click on unexecuted DF card-pile or terminal nodes
    } else {
      // Non-DF, or unexecuted DF vertex
      if (this.props.onSubtractBtnClick)
        this.props.onSubtractBtnClick({ ref: taskRef });
    }
  };
  handleDeleteClick = (e) => {
    e.stopPropagation();
    const taskRef =
      e.composedPath()[1].id ||
      e.composedPath()[2].id ||
      e.composedPath()[3].id ||
      e.composedPath()[4].id ||
      e.composedPath()[6].id ||
      e.composedPath()[8].id ||
      e.composedPath()[9].id ||
      e.composedPath()[10].id; // could be 2 layers down

    const node = this.graph.node(taskRef);

    if (node && node.type === "DF_TASK_PLACEHOLDER") {
      if (this.props.onDeleteBtnClick)
        this.props.onDeleteBtnClick({ ref: node.firstDfRef });
    } else if (
      node &&
      (node.type === "DF_EMPTY_PLACEHOLDER" || node.type === "TERMINAL")
    ) {
      return null; // No-op for click on unexecuted DF card-pile or terminal nodes
    } else {
      // Non-DF, or unexecuted DF vertex
      if (this.props.onDeleteBtnClick)
        this.props.onDeleteBtnClick({ ref: taskRef });
    }
  };

  reloadPage = () => {
    setTimeout(() => {
      this.setState({ ...this.state, isFullscreen: true });
      this.toggleZoom();
      this.props.navigate("/workflowDefs");
    }, 500);
  };

  onBackButtonClick = () => {
    if (this.props.isModified) {
      this.setState({ ...this.state, setClickedDeleteBtn: true });
    } else {
      this.reloadPage();
    }
  };

  render() {
    const { style, className } = this.props;
    return (
      <div style={style} className={`graphWrapper ${className || ""}`}>
        <Toolbar>
          {!this.props.executionMode && !this.props.showOnlyDiagram ? (
            // <IconButton onClick={() => this.props.navigate("/workflowDefs")}>
            <IconButton onClick={this.onBackButtonClick}>
              {/* <IconButton onClick={this.reloadPage}> */}
              <ArrowBack />
            </IconButton>
          ) : null}

          {this.state.setClickedDeleteBtn && (
            <ConfirmChoiceDialog
              header={"Unsaved changes"}
              message={"Are you sure you want to go back without saving?"}
              handleConfirmationValue={(confirm, deleteAll) => {
                if (confirm) {
                  this.reloadPage();
                } else {
                  this.setState({ ...this.state, setClickedDeleteBtn: false });
                }
              }}
              open={this.state.setClickedDeleteBtn}
              confirmText="Yes"
            />
          )}
          {/* {this.props.showOnlyDiagram && (
            <IconButton onClick={this.props.refresh}>
              <Refresh />
            </IconButton>
          )} */}
          {this.props &&
            this.props.showOnlyDiagram &&
            this.props.dag &&
            this.props.dag.execution && (
              <StatusBadge status={this.props.dag.execution?.status} />
            )}
          {this.state.isFullscreen ? (
            this.props.executionMode && !this.props.showOnlyDiagram ? (
              <>
                <StatusBadge status={this.props.dag.execution?.status} />
                <IconButton
                  ref={this.refreshButtonRef}
                  onClick={() => {
                    {
                      this.closeRightPanel();
                      this.props.refresh();
                    }
                  }}>
                  <Refresh />
                </IconButton>
              </>
            ) : null
          ) : this.props.executionMode && this.props.showOnlyDiagram ? ( //ticket Summary
            <IconButton
              ref={this.refreshSummaryButtonRef}
              onClick={() => {
                this.props.refresh();
              }}>
              <Refresh />
            </IconButton>
          ) : null}
          <IconButton onClick={() => this.zoomInOut("out")}>
            <ZoomInIcon />
          </IconButton>
          <IconButton onClick={() => this.zoomInOut("in")}>
            <ZoomOutIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              this.zoomHome(true);
            }}>
            <HomeIcon />
          </IconButton>
          {!this.props.showOnlyDiagram ? (
            <IconButton onClick={this.toggleZoom}>
              {this.state.isFullscreen ? (
                <FullscreenExitIcon />
              ) : (
                <ZoomOutMapIcon />
              )}
            </IconButton>
          ) : null}

          <span>Shortcut: Ctrl + scroll to zoom: </span>
          {/* <span id="myspan">Test</span> */}
        </Toolbar>

        <svg
          ref={this.svgRef}
          className="graphSvg"
          style={{ opacity: this.props.svgLoading ? 0 : 1 }}>
          <defs>
            <filter id="brightness">
              <feComponentTransfer>
                <feFuncR type="linear" slope="0.9"></feFuncR>
                <feFuncG type="linear" slope="0.9"></feFuncG>
                <feFuncB type="linear" slope="0.9"></feFuncB>
              </feComponentTransfer>
            </filter>

            <filter
              id="dropShadow"
              height="300%"
              width="300%"
              x="-75%"
              y="-75%">
              <feMorphology
                operator="dilate"
                radius="4"
                in="SourceAlpha"
                result="thicken"
              />
              <feGaussianBlur in="thicken" stdDeviation="7" result="blurred" />
              <feFlood floodColor="rgb(0,122,255)" result="glowColor" />
              <feComposite
                in="glowColor"
                in2="blurred"
                operator="in"
                result="softGlow_colored"
              />

              <feMerge>
                <feMergeNode in="softGlow_colored" />
                <feMergeNode in="SourceGraphic" />
              </feMerge>
            </filter>

            <marker
              id="endarrow"
              markerWidth="8"
              markerHeight="6"
              refX="8"
              refY="3"
              orient="auto"
              markerUnits="strokeWidth">
              <polygon points="0 0, 8 3, 0 6" />
            </marker>

            <marker
              id="startarrow"
              markerWidth="8"
              markerHeight="6"
              refX="0"
              refY="3"
              orient="auto"
              markerUnits="strokeWidth">
              <polygon points="8 0, 8 6, 0 3" />
            </marker>

            <marker
              id="endarrow-dimmed"
              markerWidth="8"
              markerHeight="6"
              refX="8"
              refY="3"
              orient="auto"
              markerUnits="strokeWidth"
              stroke="#c8c8c8"
              fill="#c8c8c8">
              <polygon points="0 0, 8 3, 0 6" />
            </marker>

            <marker
              id="startarrow-dimmed"
              markerWidth="8"
              markerHeight="6"
              refX="0"
              refY="3"
              orient="auto"
              markerUnits="strokeWidth"
              stroke="#c8c8c8"
              fill="#c8c8c8">
              <polygon points="8 0, 8 6, 0 3" />
            </marker>
          </defs>
        </svg>
        <DefaultLoader
          displayModal={
            this.props.svgLoading &&
            this.props.componentLoadedFrom !== "Definition"
          }
          message={""}
          contentStyle={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            top: this.state.isFullscreen ? "" : "65%",
            left: this.state.isFullscreen ? "" : "50%",
          }}
          overlayStyle={{
            backgroundColor: "transparent",
          }}
        />
      </div>
    );
  }

  renderVertex = (nodeId) => {
    const dagGraph = this.props.dag.graph;
    const graph = this.graph;

    const v = dagGraph.node(nodeId) || graph.node(nodeId); // synthetic nodes (e.g. DF placeholder) not found in 'dag' but preloaded into local graph.

    var vName = v.name ? v.name : "";

    var displayName = v?.displayName ?? vName.split("_").join(" ");
    var isSubWF = this.checkIfSubWfTask(nodeId);

    let retval = {
      id: v.ref,
      name: displayName,
      class:
        "type-" +
        v.type +
        (this.props?.selectedTask?.ref &&
        splitTaskReferenceName(this.props?.selectedTask?.ref) ===
          splitTaskReferenceName(v.ref) &&
        !v.ref.startsWith("LABEL_")
          ? " selected"
          : ""),
      type: v.type,
      screen: this.props.executionMode ? "Execution" : "Defination",
      isSubWF: isSubWF,
    };

    retval.class += this.checkIfTriggerTask(nodeId);

    if (v.type === TaskType.JoinTask)
      retval.class += this.checkIfJoinTaskInForkJoin(nodeId);

    switch (v.type) {
      case "EVENT":
        retval.sink = _.get(v, "taskResults[0].workflowTask.sink") || "";
        retval.height = 130;
        retval.width = 350;
        break;
      case "START_WORKFLOW":
        retval.height = 130;
        retval.width = 350;
        break;
      case "INLINE":
        retval.expression =
          _.get(v, "taskResults[0].workflowTask.inputParameters.expression") ||
          "";
        retval.height = 160;
        retval.width = 350;
        break;
      case TaskType.Default:
      case TaskType.EndOfSwitch:
      case TaskType.SwitchCase:
      case TaskType.ForkBranch:
      case TaskType.EndOfDoWhile:
      case TaskType.Label:
        // retval.shape = "rect";
        retval.height = 110;
        retval.width = 250;
        break;
      case "JSON_JQ_TRANSFORM":
        retval.expression =
          _.get(
            v,
            "taskResults[0].workflowTask.inputParameters.queryExpression"
          ) || "";
        retval.height = 160;
        retval.width = 350;
        break;
      case "HTTP":
      case "HTTP_POLL":
        retval.uri =
          _.get(
            v,
            "taskResults[0].workflowTask.inputParameters.http_request.uri"
          ) || "";
        retval.method =
          _.get(
            v,
            "taskResults[0].workflowTask.inputParameters.http_request.method"
          ) || "";
        retval.height = 130;
        retval.width = 350;
        break;
      case "SUB_WORKFLOW":
        retval.label = `${v.ref}\n(${v.name})`;
        retval.height = 130;
        retval.width = 350;
        break;
      case "TERMINAL":
        retval.label = v.name;
        retval.shape = "rect";
        retval.height = 80;
        retval.width = 80;
        retval.rx = 2;
        retval.ry = 2;
        break;
      case "ADDBTN":
        retval.label = v.name;
        retval.shape = "rect";
        retval.height = 30;
        retval.width = 30;
        retval.rx = 2;
        retval.ry = 2;
        break;
      case "TERMINATE":
        retval.label = `${v.ref}\n(terminate)`;
        retval.shape = "rect";
        break;
      case TaskType.ForkJoin:
      case "FORK_JOIN_DYNAMIC":
        // retval = composeBarNode(v, "down");
        // this.barNodes.push(v.ref);
        retval.height = 130;
        retval.width = 350;
        break;
      case TaskType.EndOfForkJoin:
      case "EXCLUSIVE_JOIN":
        // retval = composeBarNode(v, "up");
        // this.barNodes.push(v.ref);
        retval.height = 130;
        retval.width = 350;
        break;
      case "DECISION":
      case TaskType.Switch:
        retval.label = v.ref;
        // retval.shape = "diamond";
        retval.shape = "rect";
        retval.height = 200;
        retval.width = 350;
        break;
      case "DF_EMPTY_PLACEHOLDER":
        retval.label = v.status
          ? "No tasks spawned"
          : "Dynamically spawned tasks";
        retval.shape = "stack";
        break;
      case "DF_TASK_PLACEHOLDER":
        retval.label = `${v.tally.success} of ${v.tally.total} tasks succeeded`;
        retval.labelStyle = "font-size:11px; fill: black";
        if (v.tally.inProgress) {
          retval.label += `\n${v.tally.inProgress} pending`;
        }
        if (v.tally.canceled) {
          retval.label += `\n${v.tally.canceled} canceled`;
        }
        retval.firstDfRef = v.firstDfRef;
        retval.shape = "stack";
        break;
      case TaskType.DoWhile:
        // case TaskType.Label:
        // case "DO_WHILE_END":
        // retval = composeBarNode(v, "down");
        // retval.label = `${retval.label} [DO_WHILE]`;
        // this.barNodes.push(v.ref);

        retval.height = 130;
        retval.width = 350;
        break;
      default:
        retval.label = `${v.ref}\n(${v.name})`;
        retval.shape = "rect";
        retval.height = 130;
        retval.width = 350;
    }

    if (_.size(v.taskResults) > 1) {
      retval.label += `\n${v.taskResults.length} Attempts`;
    }

    if (this.props.executionMode) {
      if (v.status) {
        if (v.type !== "TERMINAL") {
          retval.class += ` status_${v.status}`;
        }
      } else {
        retval.class += " dimmed status_SKIPPED";
      }
    }

    return retval;
  };

  checkIfJoinTaskInForkJoin(nodeId) {
    // disable-node-delete
    const {
      dag: { graph: dagGraph },
    } = this.props;
    const allNodes = dagGraph.nodes();
    const currNode = dagGraph.node(nodeId);
    const currNodeIndex = allNodes.findIndex((node) => node === nodeId);

    const getNode = (id) => dagGraph.node(id);
    const nextNode = allNodes[currNodeIndex + 1];

    if (!nextNode) {
      return ""; // Return an empty string if nextNode is undefined
    }

    const checkNextNodeType = (index, type) => {
      const nextNodeId = allNodes[index];
      return nextNodeId && getNode(nextNodeId)?.name === type
        ? " forkjoinTask"
        : "";
    };

    if (
      nextNode &&
      checkNextNodeType(currNodeIndex + 1, TaskType.EndOfForkJoin)
    ) {
      return " forkjoinTask disable-node-delete disable-node-add";
    }

    return ""; // Default return an empty string if conditions are not met
  }

  checkIfTriggerTask(nodeId) {
    const {
      dag: { graph: dagGraph },
    } = this.props;
    const allNodes = dagGraph.nodes();
    const currNode = dagGraph.node(nodeId);
    const currNodeIndex = allNodes.findIndex((node) => node === nodeId);

    const excludedType = [
      TaskType.SwitchCase,
      TaskType.EndOfDoWhile,
      TaskType.ForkBranch,
      TaskType.Default,
      // TaskType.EndOfForkJoin,
      TaskType.EndTriggerApproval,
    ];
    let isExcludedType = false;
    for (let types of excludedType) {
      if (nodeId.startsWith(types)) {
        isExcludedType = true;
        break;
      }
    }
    if (isExcludedType) return "";

    const getNode = (id) => dagGraph.node(id);

    const checkPrevNodeType = (index, type) => {
      const prevNodeId = allNodes[index];
      return prevNodeId && getNode(prevNodeId)?.type === type
        ? " triggerApprovalTask"
        : "";
    };

    const checkSwitchConditions = (nodesAbove, nodesBelow, currIndex) => {
      const switchNodeAbove = nodesAbove.findLast((item) =>
        item.startsWith(TaskType.Switch)
      );
      const endOfSwitchBelow = nodesBelow.find(
        (item) =>
          item.startsWith(TaskType.EndOfSwitch) &&
          item.includes(splitTaskReferenceName(switchNodeAbove))
      );

      if (
        switchNodeAbove &&
        endOfSwitchBelow &&
        this.checkIfTriggerTask(switchNodeAbove)
      ) {
        return " triggerApprovalTask";
      }

      if (
        switchNodeAbove &&
        !endOfSwitchBelow &&
        this.checkIfTriggerTask(switchNodeAbove)
      ) {
        const topmostEOSBelow = nodesBelow.find((item) =>
          item.startsWith(TaskType.EndOfSwitch)
        );
        const switchAbove = nodesAbove.find(
          (item) =>
            item.startsWith(TaskType.Switch) &&
            item.includes(splitTaskReferenceName(topmostEOSBelow))
        );
        return switchAbove &&
          topmostEOSBelow &&
          this.checkIfTriggerTask(switchAbove)
          ? " triggerApprovalTask"
          : "";
      }

      return "";
    };

    if (currNodeIndex > 0) {
      if (checkPrevNodeType(currNodeIndex, TaskType.StartTriggerApproval)) {
        return " triggerApprovalTask disable-node-delete";
      }

      if (checkPrevNodeType(currNodeIndex, TaskType.TriggerApproval)) {
        return " triggerApprovalTask";
      }

      if (checkPrevNodeType(currNodeIndex, TaskType.FetchApproval)) {
        return " triggerApprovalTask disable-node-delete";
      }

      const currNode = allNodes[currNodeIndex];
      const nextNode = allNodes[currNodeIndex + 1];

      if (
        currNode &&
        nextNode &&
        getNode(nextNode)?.ref &&
        getNode(currNode)?.ref &&
        getNode(nextNode)?.ref.includes(TaskType.EndTriggerApproval) &&
        getNode(currNode)?.ref.includes(TaskType.EndOfSwitch)
      ) {
        return " triggerApprovalTask disable-node-delete";
      }
      if (
        checkPrevNodeType(currNodeIndex - 1, TaskType.FetchApproval) &&
        checkPrevNodeType(currNodeIndex, TaskType.Switch) &&
        // currNode.type === TaskType.Switch &&
        // currNodeIndex > 1 &&
        checkPrevNodeType(currNodeIndex - 2, TaskType.TriggerApproval)
      ) {
        return " triggerApprovalTask disable-node-delete";
      }

      const nodesAboveCurrNode = allNodes.slice(0, currNodeIndex);
      const nodesBelowCurrNode = allNodes.slice(currNodeIndex + 1);
      if (nodesAboveCurrNode.length > 1 && nodesBelowCurrNode.length > 1) {
        return checkSwitchConditions(
          nodesAboveCurrNode,
          nodesBelowCurrNode,
          currNodeIndex
        )
          ? " triggerApprovalTask"
          : "";
      }
    }

    return "";
  }

  checkIfSubWfTask(nodeId) {
    const {
      dag: { graph: dagGraph },
    } = this.props;
    const allNodes = dagGraph.nodes();
    const currNode = dagGraph.node(nodeId);
    const currNodeIndex = allNodes.indexOf(nodeId);
    let isSubWF = currNode?.taskResults?.[0]?.workflowTask?.isSubWF ?? false;

    if (!isSubWF && nodeId.startsWith(TaskType.EndOfDoWhile)) {
      const nextNodeId = allNodes[currNodeIndex + 1];
      const nextNode = dagGraph.node(nextNodeId);

      if (nextNode?.taskResults?.[0]?.workflowTask?.isSubWF) {
        isSubWF = true;
      }
    }

    return isSubWF;
  }

  expandBar(barRef) {
    const barNode = this.graph.node(barRef);
    let fanOut;
    if (barNode.fanDir === "down") {
      fanOut = this.graph.outEdges(barRef).map((e) => {
        const points = parseSvgPath(
          this.graph.edge(e).elem.querySelector("path").getAttribute("d")
        );
        return _.first(points);
      });
    } else if (barNode.fanDir === "bidir") {
      fanOut = this.graph.inEdges(barRef).map((e) => {
        const points = parseSvgPath(
          this.graph.edge(e).elem.querySelector("path").getAttribute("d")
        );
        return _.last(points);
      });
    } else {
      fanOut = this.graph.inEdges(barRef).map((e) => {
        const points = parseSvgPath(
          this.graph.edge(e).elem.querySelector("path").getAttribute("d")
        );
        return _.last(points);
      });
    }

    const barWidth = barNode.elem.getBBox().width;
    let translateX = getTranslateX(barNode.elem),
      translateY = getTranslateY(barNode.elem);
    let minX = barNode.x - barWidth / 2;
    let maxX = barNode.x + barWidth / 2;

    for (const point of fanOut) {
      const left = point[1] - BAR_MARGIN;
      const right = point[1] + BAR_MARGIN;
      if (right > maxX) maxX = right;
      if (left < minX) minX = left;
    }

    if (minX < 0) {
      maxX = maxX - minX + BAR_MARGIN;
      minX = -BAR_MARGIN;
    }

    translateX = minX;
    barNode.elem.setAttribute(
      "transform",
      `translate(${translateX}, ${translateY})`
    );

    const rect = barNode.elem.querySelector("rect");
    const currTransformY = rect.transform.baseVal[0].matrix.f;
    const newWidth = maxX - minX;
    const newTransformX = 0;
    rect.removeAttribute("transform");
    rect.setAttribute("y", currTransformY);
    rect.setAttribute("width", newWidth);

    const text = barNode.elem.querySelector("g.label > g");
    const textWidth = text.getBBox().width;
    const newTextTransformX = newTransformX + (newWidth - textWidth) / 2;
    const currTextTransformY = text.transform.baseVal[0].matrix.f;
    text.setAttribute(
      "transform",
      `translate(${newTextTransformX}, ${currTextTransformY})`
    );
  }
}

export default withResizeDetector(WorkflowGraph);
WorkflowGraph.propTypes = {
  dag: PropTypes.object,
  onClick: PropTypes.func,
  selectedTask: PropTypes.any,
  width: PropTypes.number,
  height: PropTypes.number,
  hasEditorLoaded: PropTypes.bool,
  isLoading: PropTypes.bool,
};

function composeBarNode(v, fanDir) {
  const retval = {
    id: v.ref,
    type: v.type,
    fanDir: fanDir,
    class: `bar type-${v.type}`,
    shape: "bar",
    labelStyle: "font-size:11px",
    padding: 4,
    label: `${v.name} (${v.aliasForRef || v.ref})`,
  };
  return retval;
}

function barRenderer(parent, bbox, node) {
  const group = parent.insert("g", ":first-child");
  group
    .insert("rect")
    .attr("width", bbox.width)
    .attr("height", bbox.height)
    .attr("transform", `translate(${-bbox.width / 2}, ${-bbox.height / 2})`);

  /*
  if(node.type === 'EXCLUSIVE_JOIN') {
    group.insert("rect")
    .attr("class", "underline")
    .attr("width", bbox.width)
    .attr("height", 3)
    .attr("transform", `translate(${-bbox.width/2}, ${bbox.height - 7})`);
  }*/

  node.intersect = function (point) {
    // Only spread out arrows in fan direction
    return {
      x:
        (node.fanDir === "down" && point.y > node.y) ||
        (node.fanDir === "up" && point.y < node.y)
          ? point.x
          : intersect.rect(node, point).x,
      y: point.y < node.y ? node.y - bbox.height / 2 : node.y + bbox.height / 2,
    };
  };

  return group;
}

const STACK_OFFSET = 5;
function stackRenderer(parent, bbox, node) {
  const group = parent.insert("g", ":first-child");

  group
    .insert("rect")
    .attr("width", bbox.width)
    .attr("height", bbox.height)
    .attr(
      "transform",
      `translate(${-bbox.width / 2 - STACK_OFFSET * 2}, ${
        -bbox.height / 2 - STACK_OFFSET * 2
      })`
    )
    .attr("fill", "#c7c7c7")
    .attr("stroke", "#696969");
  group
    .insert("rect")
    .attr("width", bbox.width)
    .attr("height", bbox.height)
    .attr(
      "transform",
      `translate(${-bbox.width / 2 - STACK_OFFSET}, ${
        -bbox.height / 2 - STACK_OFFSET
      })`
    )
    .attr("fill", "#c7c7c7")
    .attr("stroke", "#696969");
  group
    .insert("rect")
    .attr("width", bbox.width)
    .attr("height", bbox.height)
    .attr("transform", `translate(${-bbox.width / 2}, ${-bbox.height / 2})`)
    .attr("fill", "#c7c7c7")
    .attr("stroke", "#696969");

  // parent.selectAll(`g.label`).selectAll(`tspan`).attr("fill", "#fff");

  node.intersect = function (point) {
    const retval = intersect.rect(node, point);
    if (retval.y < node.y) retval.y -= STACK_OFFSET;
    if (retval.y >= node.y) retval.y -= STACK_OFFSET * 2;

    return retval;
  };
  return group;
}

function rectRenderer(parent, bbox, node) {
  const group = rectUI(parent, bbox, node);

  node.intersect = function (point) {
    const retval = intersect.rect(node, point);
    if (retval.y < node.y) retval.y -= STACK_OFFSET;
    if (retval.y >= node.y) retval.y -= STACK_OFFSET * 2;

    return retval;
  };

  return group;
}

function getTranslateX(elem) {
  return elem.transform.baseVal[0].matrix.e;
}
function getTranslateY(elem) {
  return elem.transform.baseVal[0].matrix.f;
}
